#import "../fragments/contact-attachments-fragment.graphql"

mutation AddAttachmentToContact($input: ContactFileAddInput!) {
    contactFilesAdd(input: $input) {
        contact {
            ...ContactAttachmentsFragment
        }
    }
}
